import { icons } from '@lifebit-ai/lds'
import { filesize } from 'filesize'
import React from 'react'

import * as styles from './ViewFormModal.styles'
import { FALLBACK_FIELD_VALUE, type FormFile } from './useViewFormModal'

type UploadedFilesProps = {
  files?: FormFile[]
  onPreviewFile?: (file: FormFile) => void
}

const formatFileSize = (size?: string): string => {
  if (!size) {
    return ''
  }

  const parsedSize = Number(size)
  if (Number.isNaN(parsedSize)) {
    return size
  }

  return filesize(parsedSize, { round: 0, standard: 'jedec' })
}

export const UploadedFiles = ({ files, onPreviewFile }: UploadedFilesProps): React.ReactElement => {
  if (!files?.length) {
    return <styles.EmptyText>{FALLBACK_FIELD_VALUE}</styles.EmptyText>
  }

  return (
    <>
      {files.map(file => {
        return (
          <styles.UploadedFileRow key={file.id}>
            <styles.UploadedFileInfo>
              <styles.UploadedFileIcon>
                <icons.File />
              </styles.UploadedFileIcon>
              <styles.UploadedFileText>
                <styles.UploadedFileName>{file.name}</styles.UploadedFileName>
                <styles.UploadedFileSize>{formatFileSize(file.size)}</styles.UploadedFileSize>
              </styles.UploadedFileText>
            </styles.UploadedFileInfo>
            <styles.UploadedFileAction>
              <button
                type="button"
                onClick={() => onPreviewFile?.(file)}
                data-testid={`uploaded-file-preview-${file.id}`}
              >
                <icons.EyeSmall />
              </button>
            </styles.UploadedFileAction>
          </styles.UploadedFileRow>
        )
      })}
    </>
  )
}
